import * as React from "react";
import type { SVGProps } from "react";
const SvgFlamingo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.76 22H5.24A3.24 3.24 0 0 1 2 18.76v-.52A3.24 3.24 0 0 1 5.24 15h13.52A3.24 3.24 0 0 1 22 18.24v.52A3.24 3.24 0 0 1 18.76 22M5.24 17A1.23 1.23 0 0 0 4 18.24v.52A1.23 1.23 0 0 0 5.24 20h13.52A1.23 1.23 0 0 0 20 18.76v-.52A1.23 1.23 0 0 0 18.76 17z"
    />
    <path
      fill="currentColor"
      d="M21 19a1 1 0 0 1-1-1c0-2.33-1.87-4.65-3.38-6.51a21 21 0 0 1-1.47-2 2.25 2.25 0 0 1-.15-2.3 2.82 2.82 0 0 1 2.5-1.32A3.18 3.18 0 0 1 19.9 7q.097-.495.1-1c0-.56-.72-2-4-2a2.72 2.72 0 0 0-3 3 7.2 7.2 0 0 0 1.21 3.35A11.1 11.1 0 0 1 16 16a1 1 0 0 1-2 0 9.37 9.37 0 0 0-1.54-4.69A8.87 8.87 0 0 1 11 7a4.7 4.7 0 0 1 5-5c4.75 0 6 2.62 6 4a9.1 9.1 0 0 1-1.23 4.28 1 1 0 0 1-1.84-.66 1.76 1.76 0 0 0-.46-1.25 1.3 1.3 0 0 0-.93-.5.9.9 0 0 0-.75.29s-.06.11.06.32q.62.915 1.33 1.76C19.79 12.23 22 15 22 18a1 1 0 0 1-1 1"
    />
    <path
      fill="currentColor"
      d="M17.5 7.5a1 1 0 0 1-1-1 5 5 0 0 1 1.86-3.57 1.001 1.001 0 1 1 1.28 1.54 3.12 3.12 0 0 0-1.14 2 1 1 0 0 1-1 1z"
    />
  </svg>
);
export default SvgFlamingo;
